import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const MobileWallet = ({ template }) => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <StyledImage
            src={messages[`${template}.mobile-wallet.image.src`]}
            alt={messages[`${template}.mobile-wallet.image.alt`]}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id={`${template}.mobile-wallet.title`} />
          </Title>
          <Subtitle>
            <FormattedMessage id={`${template}.mobile-wallet.paragraph`} />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

MobileWallet.propTypes = {
  template: PropTypes.string.isRequired,
};

export default MobileWallet;
